module.exports = __webpack_public_path__ + "static/media/plan-B5b-mobile-en.7548069e.png";